import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getWorkspaceData, ISearchData, PAGINATION_DATA, WORKSPACE_MENU, WORKSPACE_SEARCH_OPTIONS, WORKSPACE_SORT_COLUMN } from '@common/interfaces';
import { FIELD_ARRAY_WORKSPACE_LIST } from 'libs/common/src/lib/constants/table-field-constants';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { UploadDownloadService } from 'libs/common/src/lib/service/upload-download.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-super-admin-dashboard',
  templateUrl: './super-admin-dashboard.component.html',
  styleUrls: ['./super-admin-dashboard.component.scss']
})
export class SuperAdminDashboardComponent {
  workspaceList = WORKSPACE_MENU;
  fieldArray = FIELD_ARRAY_WORKSPACE_LIST;
  router = inject(Router);
  commonHttpService = inject(CommonHttpService);
  searchColumn!: string;
  searchText!: string;
  provider!: string;
  PAGINATION_DATA = PAGINATION_DATA;
  pageSize = '5';
  currentPageNumber = '1';
  status = '';
  textOnButton = 'Download Workspace List';
  loaderView: boolean = false;
  sortDigit = 'DESC';
  tableDetails: any;
  REQUEST_SEARCH_OPTIONS = Object.values(WORKSPACE_SEARCH_OPTIONS);
  count!: number;
  isStatusFilter = false;
  currentParams: any;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private commonService: CommonService,
    private uploadAndDownloadService: UploadDownloadService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService
  ) { }
  tableConfig = [
    {
      title: 'Workspace',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        isWorkspace: true,
        keys: {
          key: 'name',
          from: 'workspace',
          handleAction: (workspaceId: string) => {
            this.navigateToWorkspace(workspaceId)
          }
        }
      }
    },
    {
      title: 'Plan',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        keys: {
          key: 'planName',
          from: 'plan',
        },
      },
    },
    {
      title: 'Start Date',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        keys: {
          key: 'startDate',
          from: 'plan',
          isDate: true,
        },
      },
    },
    {
      title: 'End Date',
      hasMultiKeys: false,
      sortAction: (col: string) => {
        this.handleSortAction(col);
      },
      icon: 'sort-asc',
      config: {
        keys: {
          key: 'endDate',
          from: 'plan',
          isDate: true,
        },
      },
    },
  ]

  createWorkspace() {
    this.router.navigate(['home/main/create-workspace']);
  }
  ngOnInit(): void {
    this.loadCounters(),
      this.getAllTickets()
  }
  loadCounters() {
    this.commonHttpService.getAllWorkspacesCount().subscribe((res: any) => {
      this.workspaceList[0].count = res.data[0].count;
      this.workspaceList[1].count = res.data[1].count;
      this.workspaceList[2].count = res.data[2].count
    })
  }
  formatDate(date: string) {
    return date.split('/').reverse().join('-');
  }
  getAllTickets(param?: any) {
    this.loaderView = true;
    const params = {
      provider: this.provider,
      status: this.status,
      pageNumber: param?.pageNumber || '1',
      itemsPerPage: this.pageSize || '5',
      searchColumn: this.searchColumn || '',
      searchText: this.searchColumn === 'START_DATE'
        ? this.formatDate(this.searchText)
        : this.searchText || '',
      sortColumn: param?.sortColumn || ' ',
      sortDirection: param?.sortDirection || '',
      assignedTickets: false,
    };
    this.currentParams = params;

    const loadRequest = this.commonHttpService.getAllWorkSpaces(params);
    if (loadRequest) {
      loadRequest.subscribe({
        next: (response: any) => {
          const ticketsData = Object(response).data;
          const formatted = getWorkspaceData(ticketsData.workspaces);
          this.tableDetails = [...formatted]
          const groupedTableDetails: { [key: string]: any[] } = {};
          for (const object of this.tableDetails) {
            const date = object.Date;
            if (!groupedTableDetails.hasOwnProperty(date)) {
              groupedTableDetails[date] = [];
            }
            groupedTableDetails[date].push(object);
          }
          this.count = ticketsData.count;

          if(!param?.skipEmit){
            this.commonService.searchParam.next({
            searchColumn: param?.searchColumn,
            searchText: param?.searchText,
            sortColumn: param?.sortColumn,
            sortDirection: param?.sortDirection,
            pageNumber: param?.pageNumber,
            pageSize: param?.pageSize,
          });
          }
          this.loaderView = false;
        },
        error: () => {
          this.loaderView = false;
        },
      });
      this.currentPageNumber = param?.pageNumber;
      this.sortDigit = this.sortDigit === 'DESC' ? 'ASC' : 'DESC';
      this.changeDetectorRef.detectChanges();
    }
  }
  pageSizeChange(pageSize: string) {
    if(this.isStatusFilter) return;
    const pageCount = sessionStorage.getItem('pageSize');
    if (pageCount) {
      this.pageSize = pageCount;
    } else {
      this.pageSize = pageSize;
    }
    this.getAllTickets();
  }
  filterTickets(filter: any) {
    if(this.isStatusFilter) return;
    this.status = filter;
    this.getAllTickets();
  }
  search(searchData: ISearchData) {
    if(this.isStatusFilter) return;
    this.searchColumn = searchData.filterBy;
    this.searchText = searchData.searchStr;
    this.getAllTickets();
    this.textOnButton = 'Download Workspace List';
  }
  handleSortAction(col: string) {
    if(this.isStatusFilter) return;
    const sortAction = col.split(' ');
    const columnName = sortAction[1];
    const sortOrder = sortAction[0];
    this.sortDigit = sortOrder;
    const param = {
      sortColumn: '',
      sortDirection: this.sortDigit,
      pageNumber: this.currentPageNumber,
    };
    switch (columnName) {
      case 'WorkspaceName':
        param.sortColumn = WORKSPACE_SORT_COLUMN.WORKSPACE_NAME;
        break;
      case 'PlanName':
        param.sortColumn = WORKSPACE_SORT_COLUMN.PLAN_NAME;
        break;
      case 'StartDate':
        param.sortColumn = WORKSPACE_SORT_COLUMN.START_DATE;
        break;
      case 'EndDate':
        param.sortColumn = WORKSPACE_SORT_COLUMN.END_DATE;
        break;

      default:
        param.sortColumn = '';
        break;
    }

    this.getAllTickets(param);
  }
  navigateToWorkspace(workspaceId: string) {
    // this.requestStatusClicked = true;
    this.router.navigate(['home/main/workspace-details', workspaceId])
  }
  handleStatus(event: string){
    this.isStatusFilter = true;
    this.searchColumn = 'WORKSPACE_STATUS';
    this.searchText = event === 'ACTIVE' ? 'false' : 'true';
    this.getAllTickets({skipEmit:true});
    setTimeout(()=>{
      this.isStatusFilter = false;
    })
  }
}